<div class="modal-header">
  <h2 mat-dialog-title class="modal-title">Fetch Driver Location</h2>
  <button class="btn-close" (click)="close()" aria-label="Close dialog">
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
    </svg>
  </button>
</div>

<mat-dialog-content class="modal-body">
  <div class="form-group mb-0">
    <label class="form-label">Select Driver</label>
    <app-driver-select [options]="data.drivers" [(ngModel)]="selectedDriverLabel" [dropup]="data.dropup"
      placeholder="Select Driver">
    </app-driver-select>
    <p class="form-helper">The selected driver will receive a request to update their current GPS coordinates.</p>
  </div>
</mat-dialog-content>

<mat-dialog-actions class="modal-footer">
  <button class="btn btn-secondary" (click)="close()">Cancel</button>
  <button class="btn btn-primary" (click)="send()">
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor"
      class="icon-sm">
      <path stroke-linecap="round" stroke-linejoin="round"
        d="M6 12L3.269 3.126A59.768 59.768 0 0121.485 12 59.77 59.77 0 013.27 20.876L5.999 12zm0 0h7.5" />
    </svg>
    Send Request
  </button>
</mat-dialog-actions>